
const subdomain = window.location.hostname;
const subdomainParts = subdomain.split('.');
const domainName = subdomainParts.slice(-2).join('.');
console.log(domainName);

export const baseUrl = (key) => {
  const region = localStorage.getItem("region");

  const url = process.env[key];
  if (url?.includes("localhost")) return url;
  if (region && region !== "GULF") {
    const [protcol, path] = url.split("://");
    return `${protcol}://${region.toLocaleLowerCase()}-${path}`;
  }
  return url;
};


export const getFlag = () => {
  return localStorage.getItem('region') === 'IN'
  ? 'https://storage.googleapis.com/dev-bucket.stylifashion.com/flags/flag_in.png'
  : 'https://storage.googleapis.com/dev-bucket.stylifashion.com/GCC_Flag.svg';
}

export const getPods = () => {
  return localStorage.getItem('region') === 'IN' ? 'IND' : 'GCC';
}

export const removeFromCookie = () => {
  const cookieName = 'styli_sso_user';
  document.cookie = `${cookieName}=; domain=${domainName}; path=/;`;
};

const getCookie = (cookieName, domain) => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    // Check if the cookie starts with the specified name
    if (cookie.indexOf(`${cookieName}=`) === 0) {
      // Check if the cookie domain matches the specified domain
      if (domain && cookie.indexOf(`domain=${domain}`) === -1) {
        return cookie.substring(cookieName.length + 1);
      }
    }
  }
  return null;
};

const getJsonCookie = (cookieName, domain) => {
  const cookieValue = getCookie(cookieName, domain);
  if (cookieValue) {
    try {
      // Parse the JSON value from the cookie
      return JSON.parse(decodeURIComponent(cookieValue));
    } catch (error) {
      // Handle parsing errors if necessary
      console.error('Error parsing JSON from cookie:', error);
    }
  }

  return null; // Return null if the cookie or JSON value doesn't exist
};

const setJsonCookie = (cookieName, jsonObject, expirationDays, domain) => {
  const jsonString = JSON.stringify(jsonObject);

  let cookieString = `${cookieName}=${encodeURIComponent(jsonString)}; path=/;`;

  if (expirationDays) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);
    cookieString += `; expires=${expirationDate.toUTCString()}`;
  }

  if (domain) {
    cookieString += `; domain=${domain}`;
  }

  document.cookie = cookieString;
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user = getJsonCookie('styli_sso_user', domainName);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js  : getCurrentUser -> error', error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  const cookieName = 'styli_sso_user';
  try {
    if (user) {
      setJsonCookie(cookieName, user, 0, domainName);
      // localStorage.setItem('styli_sso_user', JSON.stringify(user));
    } else {
      // localStorage.removeItem('styli_sso_user');
      document.cookie = `${cookieName}=; domain=${domainName}; path=/;`;
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
}

export const getHolidays = () => {
  
  return [
    { id: 0, name: "Sunday" }, 
    { id: 1, name: "Monday" }, 
    { id: 2, name: "Tuesday" }, 
    { id: 3, name: "Wednesday" },
    { id: 4, name: "Thursday" },
    { id: 5, name: "Friday" },
    { id: 6, name: "Saturday" }
  ]
}

export const getHolidayFromDayNum = (holiday = []) => {
  const holidaysList = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  if(holiday.length === 0) return "";
  return holiday.map(day => holidaysList[day]).join(",");
}

// Special marker for "No Holiday" - using -1 as the ID
export const NO_HOLIDAY_ID = -1;
export const NO_HOLIDAY_MARKER = "NO_HOLIDAY";

// Check if holiday array represents "No Holiday"
export const isNoHoliday = (holiday) => {
  if (!holiday) return false;
  if (Array.isArray(holiday)) {
    return holiday.includes(NO_HOLIDAY_ID) || holiday.includes(NO_HOLIDAY_MARKER);
  }
  return holiday === NO_HOLIDAY_MARKER || holiday === "-1" || holiday === -1;
};


// Convert UI holiday selection to backend format
export const convertHolidayToBackend = (holiday) => {
  if (!holiday || holiday.length === 0) return []; // Empty = fallback to city
  if (Array.isArray(holiday) && holiday.includes(NO_HOLIDAY_ID)) {
    return -1; // API accepts -1 as No Holiday (conditions 12 & 13)
  }
  return holiday; // Return actual holiday IDs
};

// Parse holiday from backend to UI format
export const parseHolidayFromBackend = (holiday) => {
  if (!holiday) return []; // Empty = will fallback to city
  if (holiday === NO_HOLIDAY_MARKER || holiday === "-1") {
    return [NO_HOLIDAY_ID]; // Show "No Holiday" selected
  }
  //  Parse comma-separated numbers or array
  if (typeof holiday === 'string') {
    return holiday.split(",").map(day => parseInt(day, 10));
  }
  return Array.isArray(holiday) ? holiday : [];
};